import CohortList from './CohortList'
export default CohortList
